import { css } from '@emotion/react';

const mobileMenuOverrides = css`
  html,
  body {
    max-width: 100%;
    overflow-x: hidden;
  }

  #decagon-iframe {
    right: clamp(16px, 3vw, 32px) !important;
    bottom: calc(16px + env(safe-area-inset-bottom, 0px)) !important;
  }

  @media (max-width: 767px) {
    html[data-decagon-open='true'] #decagon-iframe,
    body[data-decagon-open='true'] #decagon-iframe {
      position: fixed !important;
      top: 0 !important;
      right: 0 !important;
      bottom: 0 !important;
      left: 0 !important;
      width: 100vw !important;
      height: 100vh !important;
      max-width: 100vw !important;
      max-height: 100vh !important;
      border-radius: 0 !important;
      z-index: 1000 !important;
    }
  }

  @media (min-width: 768px) {
    #decagon-iframe {
      right: 24px !important;
      bottom: 24px !important;
    }
  }

  @media (min-width: 1200px) {
    #decagon-iframe {
      right: 32px !important;
      bottom: 32px !important;
    }
  }

  @media (min-width: 992px) {
    html[data-cart-open='true'] #decagon-iframe,
    body[data-cart-open='true'] #decagon-iframe {
      z-index: 1000003 !important;
    }
  }

  html[data-mobile-menu-open='true'],
  body[data-mobile-menu-open='true'] {
    overflow: hidden;
    max-height: 100vh;
    background-color: var(--cur-color-surface-neutral, #fff);
  }

  @media (max-width: 1199px) {
    body[data-mobile-menu-open='true'] #decagon-iframe,
    html[data-mobile-menu-open='true'] #decagon-iframe {
      display: none !important;
    }
  }
`;

export default mobileMenuOverrides;
